<mat-form-field subscriptSizing="dynamic">
    <mat-label *ngIf="label()">
        {{ label() }}
    </mat-label>
    <div
        #display
        st-click-stop-propagation
        class="st-text-area__display"
        [class.st-text-area__display--edit]="inEditMode()"
        [innerHTML]="displayValue() | linky: { stripPrefix: false } | highlight: textToHighlight() : false | unsafe: 'html'"></div>
    <textarea
        #control
        matInput
        cdkTextareaAutosize
        [class.st-text-area__input--edit]="!inEditMode()"
        [ngModel]="internalValue()"
        [required]="required()"
        [disabled]="disabled()"
        [placeholder]="label() || placeholder()"
        [cdkAutosizeMaxRows]="15"
        [maxLength]="maxLength()"
        (scroll)="onScroll($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (change)="onValueChanged()"
        (ngModelChange)="onNgModelChanged($event)">
    </textarea>
    <mat-hint *ngIf="hint()">{{ hint() }}</mat-hint>
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
